import { logEvent } from 'firebase/analytics';
import { analytics } from '@/lib/firebaseConfig';
import { customEventPush } from '@/app/providers/analytics';

export type VerificationCodeEvent =
  | 'verification_code_screen_viewed'
  | 'verification_code_submitted'
  | 'verification_code_failed'
  | 'verification_code_resent';

export const trackVerificationCodeEvent = (
  eventName: VerificationCodeEvent,
  eventParams: Record<string, string | number | boolean> = {}
) => {
  try {
    if (analytics) {
      logEvent(analytics, eventName, eventParams);
    }
  } catch (error) {
    console.error(`Failed to send ${eventName} to Firebase Analytics`, error);
  }

  if (typeof window !== 'undefined') {
    const dataLayer = ((window as any).dataLayer ||= []);
    dataLayer.push({ event: eventName, ...eventParams });
  }

  void Promise.resolve(
    customEventPush({
      data: {
        event_name: eventName,
        ...eventParams,
      },
      ignoreDuplicateCheck: true,
    })
  ).catch((error) => {
    console.error(`Failed to send ${eventName} to SmartLink`, error);
  });
};
